<template>
  <div class="w-100 px-2">
    <div class="d-flex justify-content-center">
      <b-img
        class="mx-auto mt-1"
        style="height: 350px"
        :src="require('@/assets/images/illustration/thanks.svg')"
      />
    </div>
    <div class="mt-2">
      <p style="text-align: center; line-height: 2.3rem; font-size: 14pt">
        شكراً لمشاركتك، سيقوم فريق العمل بمحاولة لتشميل جميع المتقدمين في هذه
        الجلسات من المشاورات وما سيليها، وسيتم التواصل بك للتنسيق.
      </p>
      <div class="d-flex mt-4 justify-content-center">
        <b-button to="/" variant="primary" class="mx-auto">
          <div class="d-flex justify-content-center align-items-center">
            عودة للرئيسية
            <feather-icon class="ml-50" icon="ArrowLeftIcon" size="18" />
          </div>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BImg, BButton } from "bootstrap-vue";
export default {
  components: {
    BImg,
    BButton,
  },
};
</script>
